module.exports = __webpack_public_path__ + "img/ico-round-location.dbd2623e.svg";